import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type { ZekayConfig, ConfigAssetUploadResponse } from "./Config.typed";

export class ConfigModel {
  zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async getConfig(): Promise<ZekayConfig | undefined> {
    const response = await fetchZekay(this.zekayAPI + "/config");
    await expectStatuses(response, 200, 204);
    if (response.status === 204) return undefined;
    return (await response.json()) as ZekayConfig;
  }

  async updateConfig(c: ZekayConfig): Promise<void> {
    const response = await fetchZekay(this.zekayAPI + "/config", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(c),
    });
    await expectStatuses(response, 204);
  }

  async uploadConfigAsset(
    file: Blob,
    name?: string,
    field?: "logo" | "logo_qr",
  ): Promise<ConfigAssetUploadResponse> {
    const form = new FormData();
    const filename = (file as Blob & { name?: string }).name;
    if (filename) form.append("File", file, filename);
    else form.append("File", file);
    if (name) form.append("Name", name);
    if (field) form.append("Field", field);
    const response = await fetchZekay(`${this.zekayAPI}/config/assets`, {
      method: "POST",
      body: form,
    });
    await assertResponseOk(response);
    return (await response.json()) as ConfigAssetUploadResponse;
  }

  async deleteConfigAsset(field: "logo" | "logo_qr"): Promise<void> {
    const response = await fetchZekay(`${this.zekayAPI}/config/assets`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ field }),
    });
    await expectStatuses(response, 204);
  }

  async getGoogleLabels(): Promise<string[]> {
    const response = await fetchZekay(this.zekayAPI + "/newsletter/labels");
    await expectStatuses(response, 200, 204);
    if (response.status === 204) return [];
    return (await response.json()) as string[];
  }
}
